export default __webpack_public_path__ + "static/media/0770ROUGE.200d30c7.pdf";